import { Flex } from '@grupoboticario/flora-react';
import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 170px;

  svg.upload {
    display: block;
    margin: 10px auto;
    color: #b4b4b4;
    box-sizing: content-box;
    padding: 16px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid #cfced3;
  }
  p {
    text-align: center;
    color: #666666;
  }
`;

export const Wrapper = styled(Flex)`
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.shape};
  min-height: 340px;
  width: 350px;
  flex-direction: column;
  justify-content: center;
`;
